import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import slugify from 'slugify';
import CallToAction from '../components/common/CallToAction';
// import Rating from 'react-rating';
import ProductGrid from './ProductGrid';
// import InputRangeWrapper from '../components/form/InputRangeWrapper';
// import LazyLoad from 'react-lazyload';
import { frontloadConnect } from 'react-frontload';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import _ from 'lodash';

import { addToCart } from '../actions/shopping-cart';
import { toggleWishlistItem } from '../actions/profile';
import { lockScroll } from '../actions/common';
import { getProducts, setFilter, getBrands, setSort, setPage, getCountByCategory } from '../actions/material';
import { getSEO } from '../actions/seo'

import { SEO_TEXT_CAT, PROMOTIONS } from '../assets/constant';

import SelectBox from '../components/form/SelectBox';
import Pagination from '../components/common/Pagination';
import FilterMenuComponent from '../components/product/FilterMenuComponent';
import BrandCheckbox from '../components/product/BrandCheckbox';

import Fuse from 'fuse.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Page from '../components/Page';
import { getRoute, createURLFromFilter } from '../assets/util';
import * as QueryString from "query-string"
import { faFilter, faChevronDown, faChevronRight, faTimes } from '@fortawesome/pro-light-svg-icons';
// import BrandSlider from '../components/brand/Slider';

const MAX_PRICE = 5000; //for price filtering
let title = 'ร้านค้าออนไลน์'
let brandTitle = ''
const frontload = async props => {
    const { pathname } = props.location
    return await props.getSEO(pathname)
}

const sortOptions = [
    { label: 'สินค้าใหม่', value: 'new_arrivals' },
    { label: 'สินค้าขายดี', value: 'best_sellers' },
    { label: 'ราคาต่ำ - สูง', value: 'plth' },
    { label: 'ราคาสูง - ต่ำ', value: 'phtl' },
    { label: 'เรทติ้งสูงสุด', value: 'top_rate' },
    { label: 'แบรนด์ A ถึง Z', value: 'batz' },
    { label: 'แบรนด์ Z ถึง A', value: 'bzta' },
];

class StoreGrid extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sortVisible: false,
            categoryFilterVisible: false,
            selectingCategory: null,
            categoryVisible: false,
            priceVisible: false,
            brandVisible: false,
            ratingVisible: false,
            promotionVisible: false,
            filterWindowVisible: false,
            vh: 500,
            priceRange: { min: 0, max: MAX_PRICE },
            priceRangeForDisplay: { min: 0, max: MAX_PRICE },
            page: this.props.page,
            rateFilter: 0,
            filter: { brand_id: [], promotion: this.props.filter.promotion ? this.props.filter.promotion : [0, 0, 0, 0, 0] },
            brandsChoiceFilter: "",
            filter_value: {},
            breadCrumb: [],
            brandBanner: null,
            brandListFilter: null,
            applyingFilter: {
                category: null,
                promotion: [0, 0, 0, 0, 0],
                price: [],
                brand: null,
                rating: null,
                mat_var_id: null,
                keyword: null,
            }
        }
        this.updateDimensions = this.updateDimensions.bind(this);
        this.renderBreadCrumb = this.renderBreadCrumb.bind(this)
        this.setCategoryFilter = this.setCategoryFilter.bind(this);
        this.sortHandleClick = this.sortHandleClick.bind(this);
        this.sortHandleOutsideClick = this.sortHandleOutsideClick.bind(this);
        this.categoryFilterHandleClick = this.categoryFilterHandleClick.bind(this);
        this.categoryFilterHandleOutsideClick = this.categoryFilterHandleOutsideClick.bind(this);
        this.promotionFilterHandleClick = this.promotionFilterHandleClick.bind(this);
        this.promotionFilterHandleOutsideClick = this.promotionFilterHandleOutsideClick.bind(this);
        this.filterDrawerHandleClick = this.filterDrawerHandleClick.bind(this);
        this.filterDrawerHandleOutsideClick = this.filterDrawerHandleOutsideClick.bind(this);
        this.setPriceFilter = this.setPriceFilter.bind(this);
        this.closeFilterWindow = this.closeFilterWindow.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.renderBrandsCheckbox = this.renderBrandsCheckbox.bind(this);
        this.clearAllFilters = this.clearAllFilters.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.refresh = this.refresh.bind(this);
        this.setSortField = this.setSortField.bind(this);
        this.setPromotionFilter = this.setPromotionFilter.bind(this);
        this.handleUrl = this.handleUrl.bind(this)
        this._preFilter = _.debounce((newFilter, isApplying = true) => {
            this.preFilter(newFilter, isApplying);
        }, 500);
        this.renderSEOText = this.renderSEOText.bind(this)
        this.renderCurrentApplyingFilter = this.renderCurrentApplyingFilter.bind(this)
        this.getSubCats = this.getSubCats.bind(this)
        this.renderApplyingCategory = this.renderApplyingCategory.bind(this)
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions.bind(this));
        this.setState({ vh: window.innerHeight * 0.01 * 100 });
        /* eslint-disable */
        $.HSCore.init();
        /* eslint-enable */

        // Handle URL parameters if they exist
        const { param1, param2, param3, param4 } = this.props.match.params;

        // If no parameters, explicitly call refresh to load initial products
        if (!param1 && !param2 && !param3 && !param4 && !this.props.location.search) {
            this.refresh();
            this.props.getBrands();
        } else {
            this.handleUrl();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.sortHandleOutsideClick, false);
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentDidUpdate(prevProps, prevState) {
        // Handle URL/route changes
        if (!_.isEqual(this.props.match, prevProps.match) || this.props.location.search !== prevProps.location.search) {
            const currentQueryObj = QueryString.parse(this.props.location.search)
            const prevQueryObj = QueryString.parse(prevProps.location.search)
            let edited = _.reduce(currentQueryObj, function (result, value, key) { return _.isEqual(value, prevQueryObj[key]) ? result : result.concat({ [key]: value }); }, [])[0];
            if (edited && edited.q) {
                return;
            }
            this.handleUrl()
            return;
        }

        if (!_.isEqual(this.props.filter, prevProps.filter)) {
            this.processFilterForBanner(this.props.filter);
            this.props.setPage(1, this.props.filter.brand_en);
            this.refresh();
            this.props.getBrands(Object.assign({}, _.pick(this.props.filter, ['cat1_id', 'cat2_id', 'cat3_id', 'promotion', 'keyword'])));
            if (_.isEqual(this.props.filter.priceRange, prevProps.filter.priceRange)) {
                window.scrollTo(0, 0);
            }
            return;
        }

        // Handle page changes only if not caused by filter change
        if (this.props.page !== prevProps.page && _.isEqual(this.props.filter, prevProps.filter)) {
            this.refresh();
            window.scrollTo(0, 0);
            return;
        }

        // Handle authentication changes
        if (this.props.authenticated !== prevProps.authenticated) {
            this.refresh();
            window.scrollTo(0, 0);
            return;
        }

        // Handle wishlist changes
        if (prevProps.addWishlistResult === null && this.props.addWishlistResult === true) {
            this.refresh();
            return;
        }

        if (prevProps.deleteWishlistResult === null && this.props.deleteWishlistResult === true) {
            this.refresh();
            return;
        }

        // Handle sort changes
        if (prevProps.sort !== this.props.sort) {
            this.setState({ page: 1, sortVisible: false });
            this.refresh();
            return;
        }

        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.props.getSEO(this.props.location.pathname)
        }

        if (!_.isEqual(this.state.applyingFilter, prevState.applyingFilter)) {
            const { applyingFilter } = this.state
            let f = _.pick(applyingFilter, ['category', 'promotion', 'keyword']);
            if (_.isEqual(f.promotion, [0, 0, 0, 0, 0])) {
                delete f.promotion;
            }
            this.props.getBrands({ ...f.category, promotion: f.promotion, keyword: f.keyword });
            this.props.getCountByCategory(null, null, applyingFilter.brand, null, applyingFilter)
        }
    }

    updateDimensions() {
        let vh = window.innerHeight * 0.01 * 100;
        this.setState({ vh });
    }

    /**
     * Extracts brand information from URL parameter
     * @param {string} param - URL parameter that might contain brand
     * @returns {{brandString: string, filterObj: Object, breadcrumb: Object}} Brand info, filter object and breadcrumb item
     */
    extractBrandInfo(param) {
        if (!param) return { brandString: null, filterObj: {}, breadcrumb: null };

        const brandString = param.substr(0, param.indexOf('?') === -1 ? param.length : param.indexOf('?'));
        return {
            brandString,
            filterObj: { brand_en: brandString },
            breadcrumb: { name: brandString, link: brandString, type: "brand" }
        };
    }

    /**
     * Processes category parameters to build filter object and breadcrumbs
     * @param {Object} params - URL parameters containing category info
     * @param {Object} initialFilter - Initial filter object to extend
     * @param {Array} categories - Available categories
     * @param {string} currentLanguage - Current UI language
     * @returns {{filterObj: Object, breadcrumbs: Array, filterCat: Object}} Updated filters and breadcrumbs
     */
    processCategoryChain(params, initialFilter, categories, currentLanguage) {
        const { param1, param2, param3 } = params;
        let filterObj = { ...initialFilter };
        const breadcrumbs = [];
        let filterCat = null;

        // Process first level category
        if (param1) {
            const cat1Index = _.findIndex(categories, (c) => slugify(c.category, { lower: true }) === param1.substr(0, param1.indexOf('?') === -1 ? param1.length : param1.indexOf('?')));
            if (cat1Index !== -1) {
                filterObj.cat1_id = categories[cat1Index].cat1_id;
                filterCat = categories[cat1Index];
                breadcrumbs.push({
                    link: slugify(categories[cat1Index].category, { lower: true }),
                    name: currentLanguage === 'th' ? categories[cat1Index].category_th : categories[cat1Index].category
                });

                // Process second level category
                if (param2) {
                    const cat2Index = _.findIndex(categories[cat1Index].subCategories,
                        (c) => slugify(c.category, { lower: true }) === param2.substr(0, param2.indexOf('?') === -1 ? param2.length : param2.indexOf('?'))
                            && c.cat1_id === filterObj.cat1_id);

                    if (cat2Index !== -1) {
                        const cat2 = categories[cat1Index].subCategories[cat2Index];
                        filterObj.cat2_id = cat2.cat2_id;
                        filterCat = cat2;
                        breadcrumbs.push({
                            link: slugify(cat2.category, { lower: true }),
                            name: currentLanguage === 'th' ? cat2.category_th : cat2.category
                        });

                        // Process third level category
                        if (param3) {
                            const cat3Index = _.findIndex(cat2.subCategories,
                                (c) => slugify(c.category, { lower: true }) === param3.substr(0, param3.indexOf('?') === -1 ? param3.length : param3.indexOf('?'))
                                    && c.cat1_id === filterObj.cat1_id
                                    && c.cat2_id === filterObj.cat2_id);

                            if (cat3Index !== -1) {
                                const cat3 = cat2.subCategories[cat3Index];
                                filterObj.cat3_id = cat3.cat3_id;
                                filterCat = cat3;
                                breadcrumbs.push({
                                    link: slugify(cat3.category, { lower: true }),
                                    name: currentLanguage === 'th' ? cat3.category_th : cat3.category
                                });
                            }
                        }
                    }
                }
            }
        }

        return { filterObj, breadcrumbs, filterCat };
    }

    /**
     * Processes query parameters to update filter object
     * @param {string} search - URL search string
     * @param {Object} initialFilter - Initial filter object to extend
     * @returns {Object} Updated filter object with query parameters
     */
    processQueryParams(search, initialFilter) {
        if (!search) return initialFilter;

        const filterObj = { ...initialFilter };
        const queryObj = QueryString.parse(search);

        if (queryObj.products) {
            filterObj.mat_var_id = _.map(queryObj.products.split(","), (s) => parseInt(s, 10));
        }

        if (queryObj.promotion) {
            const promotionString = queryObj.promotion.split("-");
            if (_.some(promotionString, (p) => p === "1")) {
                filterObj.promotion = _.map(promotionString, (p, i) => p === "1" ? `p00${i + 1}` : 0);
            }
        }

        if (queryObj.origin) filterObj.origin = queryObj.origin;
        if (queryObj.keyword) filterObj.keyword = queryObj.keyword;
        if (queryObj.event) filterObj.event = queryObj.event;

        return filterObj;
    }

    /**
     * Creates applying filter object from filter object
     * @param {Object} filterObj - Current filter object
     * @returns {Object} Applying filter object
     */
    createApplyingFilter(filterObj) {
        return {
            mat_var_id: _.isEqual(_.pick(filterObj, ["mat_var_id"]), {}) ? null : _.pick(filterObj, ["mat_var_id"]).mat_var_id,
            category: _.pick(filterObj, ['cat1_id', 'cat2_id', 'cat3_id']),
            promotion: _.isEqual(_.pick(filterObj, ['promotion']), {}) ? [0, 0, 0, 0, 0] : _.pick(filterObj, ['promotion']).promotion,
            brand: filterObj.brand_en,
            keyword: filterObj.keyword,
            event: filterObj.event,
        };
    }

    /**
     * Processes the current URL to set up filters, breadcrumbs, and brand/category information.
     */
    handleUrl() {
        const { categories, currentLanguage } = this.props;
        const { param1, param2, param3, param4 } = this.props.match.params;

        // Initialize empty filter and breadcrumbs
        let filterObj = {}, breadcrumbs = [], filterCat = null;

        // Only process parameters if they exist
        if (param1) {
            // Check if param1 is a brand
            const catIndex = _.findIndex(categories, (c) => slugify(c.category, { lower: true }) === param1);

            if (catIndex === -1) {
                // Process brand parameters
                const { brandString, filterObj: brandFilter, breadcrumb } = this.extractBrandInfo(param1);
                filterObj = brandFilter;
                if (breadcrumb) breadcrumbs.push(breadcrumb);
                brandTitle = brandString;

                // Process categories after brand
                const { filterObj: categoryFilter, breadcrumbs: categoryBreadcrumbs, filterCat: newFilterCat } =
                    this.processCategoryChain({ param1: param2, param2: param3, param3: param4 }, filterObj, categories, currentLanguage);
                filterObj = categoryFilter;
                breadcrumbs = [...breadcrumbs, ...categoryBreadcrumbs];
                filterCat = newFilterCat;
            } else {
                // Process categories directly
                const { filterObj: categoryFilter, breadcrumbs: categoryBreadcrumbs, filterCat: newFilterCat } =
                    this.processCategoryChain({ param1, param2, param3, param4 }, filterObj, categories, currentLanguage);
                filterObj = categoryFilter;
                breadcrumbs = categoryBreadcrumbs;
                filterCat = newFilterCat;
            }
        }

        // Process query parameters
        filterObj = this.processQueryParams(this.props.location.search, filterObj);

        // Update title if needed
        if (filterCat && !filterCat.brand) {
            title = currentLanguage === 'th' ? filterCat.category_th : filterCat.category;
        }

        // Always update state and trigger data fetching, even with empty filters
        console.log("handleUrl", filterObj);
        this.props.setFilter(filterObj);
        this.props.getBrands(_.pick(filterObj, ['cat1_id', 'cat2_id', 'cat3_id', 'promotion', 'keyword', 'event']));

        this.setState({
            breadCrumb: breadcrumbs,
            applyingFilter: this.createApplyingFilter(filterObj)
        }, () => {
            this.processFilterForBanner(filterObj);
        });
    }

    sortHandleClick() {
        // console.log(this.state.sortVisible);
        if (!this.state.sortVisible) {
            document.addEventListener('click', this.sortHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.sortHandleOutsideClick, false);
        }
        const { lockScroll } = this.props;
        lockScroll(!this.state.sortVisible)
        this.setState(prevState => ({
            sortVisible: !prevState.sortVisible
        }))
    }

    sortHandleOutsideClick(e) {
        if (!this.sortBox) {
            return;
        }
        if (this.sortBox.contains(e.target)) {
            return;
        }

        this.sortHandleClick();
    }

    categoryFilterHandleClick() {
        if (!this.state.categoryFilterVisible) {
            document.addEventListener('click', this.categoryFilterHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.categoryFilterHandleOutsideClick, false);
        }
        const { lockScroll } = this.props;
        lockScroll(!this.state.categoryFilterVisible)
        this.setState(prevState => ({
            categoryFilterVisible: !prevState.categoryFilterVisible,
            selectingCategory: null,
        }))
    }

    categoryFilterHandleOutsideClick(e) {
        // const parent = this.categoryFilterBox.getBoundingClientRect();
        const target = e.target.getBoundingClientRect();

        // console.log (this.categoryFilterBox, e.target, this.categoryFilterBox.contains(e.target))
        if (!this.categoryFilterBox) {
            return;
        }
        if ((target.x === 0 && target.width === 0 && target.y === 0 && target.height === 0) || this.categoryFilterBox.contains(e.target)) {
            return;
        }

        this.categoryFilterHandleClick();
    }

    promotionFilterHandleClick() {
        if (!this.state.promotionFilterVisible) {
            document.addEventListener('click', this.promotionFilterHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.promotionFilterHandleOutsideClick, false);
        }
        const { lockScroll } = this.props;
        lockScroll(!this.state.promotionFilterVisible)
        this.setState(prevState => ({
            promotionFilterVisible: !prevState.promotionFilterVisible,
            // selectingPromotion: null,
        }))
    }

    promotionFilterHandleOutsideClick(e) {
        // const parent = this.promotionFilterBox.getBoundingClientRect();
        const target = e.target.getBoundingClientRect();

        if (!this.promotionFilterBox) {
            return;
        }
        if ((target.x === 0 && target.width === 0 && target.y === 0 && target.height === 0) || this.promotionFilterBox.contains(e.target)) {
            return;
        }

        this.promotionFilterHandleClick();
    }

    filterDrawerHandleClick() {
        if (!this.state.filterWindowVisible) {
            document.addEventListener('click', this.filterDrawerHandleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.filterDrawerHandleOutsideClick, false);
        }
        const { lockScroll } = this.props;
        lockScroll(!this.state.filterWindowVisible)
        this.setState(prevState => ({
            filterWindowVisible: !prevState.filterWindowVisible
        }))
    }

    filterDrawerHandleOutsideClick(e) {
        const target = e.target.getBoundingClientRect();

        if (!this.filterDrawerBox) {
            return;
        }
        if ((target.x === 0 && target.width === 0 && target.y === 0 && target.height === 0) || this.filterDrawerBox.contains(e.target)) {
            return;
        }

        this.filterDrawerHandleClick();
    }

    toggleState(stateName) {
        this.setState((prev) => ({ [stateName]: !prev[stateName] }));
    }

    closeFilterWindow() {
        this.setState({
            filterWindowVisible: false,
            categoryVisible: false,
            priceVisible: false,
            brandVisible: false,
            ratingVisible: false,
        });
    }

    preFilter(filter) {
        this.props.setFilter(filter);
        this.setState({ page: 1 });
        this.refresh();
    }

    setCategoryFilter(category, isApplying = true) {
        const { applyingFilter } = this.state
        const newApplyingFilter = JSON.parse(JSON.stringify(applyingFilter))
        newApplyingFilter.category = category
        this.setState({ applyingFilter: newApplyingFilter })
    }

    setBrandFilter(brand_en, isAdding = true, isApplying = true) {
        let { filter } = this.props;
        if (!isApplying) {
            filter = this.state.applyingFilter
        }

        const newFilter = JSON.parse(JSON.stringify(filter));
        if (isAdding) {
            newFilter.brand = brand_en
        } else {
            newFilter.brand = null
        }

        // if (isAdding) {
        //     if (!Array.isArray(newFilter.brand_id)) {
        //         newFilter.brand_id = [];
        //     }
        //     newFilter.brand_id.push(brand_id);
        // } else {
        //     _.remove(newFilter.brand_id, (n) => n === brand_id);
        //     if (newFilter.brand_id.length === 0) {
        //         delete newFilter.brand_id;
        //     }
        // }
        if (isApplying) {
            this.preFilter(newFilter);
            // this.setState({filter_value: newFilter, filter: newFilter});
        } else {
            this.setState({ applyingFilter: newFilter })
            // this.props.setFilter(newFilter);
            // this.setState({filter_value: newFilter, filter: newFilter});
        }
    }

    setPriceFilter(price_range, isApplying = true) {
        const { filter } = this.props;
        price_range.max = price_range.max > MAX_PRICE ? MAX_PRICE : price_range.max;
        const newFilter = JSON.parse(JSON.stringify(filter));
        delete newFilter.priceRange;
        newFilter.priceRange = { min: price_range.min, max: price_range.max };
        if (isApplying) {
            this._preFilter(newFilter);
        } else {
            this.setState({ filter_value: newFilter });
        }
    }

    setRateFilter(rate, isApplying = true) {
        const { filter } = this.props;
        const newFilter = JSON.parse(JSON.stringify(filter));
        newFilter.rating = rate;
        this.setState({ rateFilter: rate });
        if (isApplying) {
            this.preFilter(newFilter);
        } else {
            this.setState({ filter_value: newFilter });
        }
    }

    setPromotionFilter(pro, index, isApplying = true) {
        if (isApplying) {
            const { filter } = this.props;
            let newFilter = Object.assign({}, filter)

            if (newFilter.brand_id && newFilter.brand_id.length === 0) {
                delete newFilter.brand_id
            }
            if (!newFilter.promotion) {
                newFilter.promotion = [0, 0, 0, 0, 0]
            }
            if (newFilter.promotion[index] === pro) {
                newFilter.promotion.splice(index, 1, 0)
            } else {
                newFilter.promotion.splice(index, 1, pro)
            }
            const proQuery = _.map(newFilter.promotion, (p) => p ? 1 : 0).join("-")

            // const varIds = filter.mat_var_id ? filter.mat_var_id.join(",") : null
            const newQuery = QueryString.parse(this.props.location.search)
            newQuery.promotion = proQuery;
            const createNewURL = this.props.match.url + "?" + QueryString.stringify(newQuery) //(varIds ? `products=${varIds}&` : "") + "promotion=" + proQuery
            this.props.history.push(createNewURL)
        } else {
            const { applyingFilter } = this.state
            let newFilter = Object.assign({}, applyingFilter)
            if (pro) {
                if (!newFilter.promotion) {
                    newFilter.promotion = [0, 0, 0, 0, 0]
                }
                if (newFilter.promotion[index] === pro) {
                    newFilter.promotion.splice(index, 1, 0)
                } else {
                    newFilter.promotion.splice(index, 1, pro)
                }
            } else {
                if (newFilter.promotion) {
                    delete newFilter.promotion
                }
            }
            this.setState((prev) => { return { applyingFilter: newFilter } })
        }
        // if (isApplying) {
        // this.preFilter(newFilter);
        // this.setState({filter_value: newFilter, filter: newFilter, page: 1});
        // } else {
        // this.props.setFilter(newFilter);
        // this.setState({filter_value: newFilter, filter: newFilter});
        // }
    }

    renderBrandsCheckbox(brands, isApplying = true, responsive = false) {
        const { brandsChoiceFilter, applyingFilter } = this.state;
        const { match: { params: { param1, param2, param3, param4 } } } = this.props;
        let bs;
        if (brandsChoiceFilter !== "") {
            const options = {
                shouldSort: true,
                includeScore: true,
                includeMatches: true,
                threshold: 0.6,
                location: 0,
                distance: 30,
                maxPatternLength: 32,
                minMatchCharLength: 1,
                keys: [
                    "brand_en"
                ]
            };
            var fuse = new Fuse(brands, options);
            let results = fuse.search(brandsChoiceFilter);
            // console.log (results);

            bs = _.map(results, _.property("item"));
            // console.log (bs);
        } else {
            bs = brands;
        }
        let checkedBS = bs, unCheckedBS = [];

        const brandFilterValue = this.state.filter_value.brand_id || this.props.filter.brand_id;
        if (brandFilterValue) {
            const cbs = Array.isArray(brandFilterValue) ? brandFilterValue : [brandFilterValue];
            checkedBS = _.filter(brands, (b) => cbs.indexOf(b.brand_id) !== -1)
            unCheckedBS = _.filter(brands, (b) => cbs.indexOf(b.brand_id) === -1)
        }
        const tailUrl = _.compact([param1, param2, param3, param4]).join("/")
        return _.map(checkedBS.concat(unCheckedBS), (brand, index) => {
            return (
                <BrandCheckbox key={brand.brand_id + " " + index} responsive={responsive} brand={brand} tailUrl={tailUrl} setBrandFilter={(v) => { this.setBrandFilter(brand.brand_en, v, isApplying) }} filterValue={responsive ? brand.brand_en === applyingFilter.brand : brand.brand_en === this.props.filter.brand_en} query={this.props.location.search} />
            );
        });
    }

    clearAllFilters(responsive) {
        if (!responsive) {
            this.props.history.push("/shop")
        } else {
            // this.setState({
            //     priceRange: {min: 0, max: MAX_PRICE},
            //     rateFilter: 0,
            //     filter: {brand_id: []},
            //     brandsChoiceFilter: "",
            //     filter_value: {},
            // });
            this.setState({
                applyingFilter: {
                    category: null,
                    promotion: [0, 0, 0, 0, 0],
                    price: [],
                    brand: null,
                    rating: null,
                    mat_var_id: null,
                    keyword: null,
                }
            })
            // this.preFilter({});
        }
    }

    applyFilter() {
        const { applyingFilter } = this.state;
        const { categories } = this.props;
        this.setState({ filterWindowVisible: false });

        let cat1, cat2, cat3
        if (applyingFilter.category) {
            const { cat1_id, cat2_id, cat3_id } = applyingFilter.category
            cat1 = _.find(categories, (c) => c.cat1_id === cat1_id)
            cat2 = _.find(cat1.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id)
            cat3 = _.find(cat2.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id && c.cat3_id === cat3_id)
        }

        const proQuery = _.map(applyingFilter.promotion, (p) => p ? 1 : 0).join("-")
        const varIds = applyingFilter.mat_var_id ? applyingFilter.mat_var_id.join(",") : null
        const newUrl = "/shop" + (applyingFilter.brand ? "/" + applyingFilter.brand : "") + (cat1 ? "/" + slugify(cat1.category, { lower: true }) : "") + (cat2 ? "/" + slugify(cat2.category, { lower: true }) : "") + (cat3 ? "/" + slugify(cat3.category, { lower: true }) : "")
        let newQuery = QueryString.parse(this.props.location.search);
        newQuery = { ...newQuery, products: varIds, promotion: _.compact(proQuery).length !== 0 && proQuery !== "0-0-0-0-0" ? proQuery : null, keyword: applyingFilter.keyword }
        newQuery = _.pickBy(newQuery, _.identity);
        const queryString = "?" + QueryString.stringify(newQuery) //(varIds ? `products=${varIds}&` : "") + (_.compact(proQuery).length !== 0 ? ("promotion=" + proQuery) : "")
        this.props.history.push({ pathname: newUrl, search: queryString })
    }

    refresh() {
        // Update refresh to use current page and maintain consistent parameters
        this.props.getProducts(this.props.page, 20, false);
    }

    setSortField(value, mobile = true) {
        if (mobile) {
            this.sortHandleClick()
        }
        this.props.setSort(value);
    }

    renderBreadCrumb() {
        const { breadCrumb } = this.state
        return _.map(breadCrumb, (bc, i) => {
            let linkConcat = `${bc.link}`

            _.times(i, (n) => {
                linkConcat = `${breadCrumb[i - (n + 1)].link}/` + linkConcat
            })
            linkConcat = "/shop/" + linkConcat // (brandLink? "/store/": "/shop/") + linkConcat
            return <li key={`bt_breadcrumb_${bc.link}`}><Link to={linkConcat}>{bc.name}</Link>{i !== breadCrumb.length - 1 && <FontAwesomeIcon icon={["fal", "chevron-right"]} className="ml-2" />}</li>
        })

    }

    processFilterForBanner(filter) {
        if (!filter) {
            return null
        }
        const brandFilter = filter.brand_id || filter.brand_en
        const catFilter = _.pick(filter, ["cat1_id"])
        if (brandFilter) {
            let type = filter.brand_id ? "id" : "en"
            if ((Array.isArray(brandFilter) && brandFilter.length === 1) || brandFilter) {
                const brandValue = Array.isArray(brandFilter) ? brandFilter[0] : brandFilter
                fetch(getRoute(`/api/brand`), {
                    method: 'post',
                    accept: 'application/json',
                    body: JSON.stringify({ ["brand_" + type]: brandValue }),
                    credentials: 'include'
                })
                    .then((response) => response.json())
                    .then((brand) => {
                        if ([11, 12, 16].includes(catFilter.cat1_id)) {
                            this.setState({ brandBanner: brand, catSEOText: catFilter.cat1_id })
                        } else {
                            this.setState({ brandBanner: brand, catSEOText: null })
                        }
                    })
            } else {
                if ([11, 12, 16].includes(catFilter.cat1_id)) {
                    this.setState({ brandBanner: null, catSEOText: catFilter.cat1_id })
                } else {
                    this.setState({ brandBanner: null, catSEOText: null })
                }
            }
        } else if (catFilter) {
            if ([11, 12, 16].includes(catFilter.cat1_id)) {
                this.setState({ catSEOText: catFilter.cat1_id, brandBanner: null })
            } else {
                this.setState({ catSEOText: null, brandBanner: null })
            }
        } else {
            this.setState({ brandBanner: null, catSEOText: null })
        }

    }

    renderHeaderBanner(brandBanner) {
        if (!brandBanner) {
            return null
        }
        return (
            <div className="row">
                <div className="col-12">
                    <div className="store-header d-flex justify-content-between banner-content">
                        <div className="brand-title">
                            {brandBanner.image && <div className="brand-img">
                                <img src={brandBanner.image} alt={brandBanner.brand_en} />
                            </div>}
                            <div className="brand-name">
                                <div><h1 className="mb-0">{brandBanner.brand_en}</h1></div>
                                {brandBanner.shop_in_shop ? <div>{brandBanner.shop_in_shop ? <Link to={brandBanner.link_name}>เยี่ยมชมหน้าร้านทางการ <FontAwesomeIcon icon={faChevronRight} /></Link> : null}</div> : null}
                            </div>
                        </div>
                        <div className="brand-stats">

                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderSEOText() {
        const { catSEOText } = this.state
        if (!catSEOText) {
            return null
        } else {
            const temp = SEO_TEXT_CAT[catSEOText]
            if (temp) {
                return _.map(temp.headers, (h, i) => {
                    return [(
                        <h2 key={"seo_header_" + i}>{h}</h2>
                    ), (
                        <p key={"seo_content_" + i}>{temp.contents[i]}</p>
                    )]
                })
            }
        }
    }

    removeApplyingFilter(type, value = null, responsive = true) {
        const { categories, currentLanguage } = this.props;
        if (responsive) {
            const { applyingFilter } = this.state
            const newFilter = Object.assign({}, applyingFilter)
            if (type === "category") {
                newFilter.category = null
            } else if (type === "brand") {
                newFilter.brand = null
            } else if (type === "promotion") {
                newFilter.promotion[value] = 0
            } else if (type === "product") {
                newFilter.mat_var_id = null
            } else if (type === "origin") {
                newFilter.origin = null
            } else if (type === "keyword") {
                newFilter.keyword = null
            } else if (type === "event") {
                newFilter.event = null
            }

            this.setState({ applyingFilter: newFilter })
        } else {
            const newFilter = Object.assign({}, this.props.filter)
            if (type === "category") {
                delete newFilter.cat1_id
                delete newFilter.cat2_id
                delete newFilter.cat3_id
            } else if (type === "brand") {
                newFilter.brand_en = null
            } else if (type === "promotion") {
                newFilter.promotion[value] = 0
            } else if (type === "product") {
                newFilter.mat_var_id = null
            } else if (type === "origin") {
                newFilter.origin = null
            } else if (type === "keyword") {
                newFilter.keyword = null
            } else if (type === "event") {
                newFilter.event = null
            }
            const { url, queryString } = createURLFromFilter(newFilter, null, categories, currentLanguage);
            this.props.history.push({ pathname: url, search: queryString })
        }
    }

    renderCurrentApplyingFilter(type, value, responsive = true) {
        const { currentLanguage, categories } = this.props
        if (!value) return null;
        if (type === "keyword") {
            return <span key={"brand_" + value} className="filter-label"><span>ค้นหา: {value}</span><span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.removeApplyingFilter("keyword", null, responsive) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
        } else if (type === "category") {
            const { cat1_id, cat2_id, cat3_id } = value
            const cat1 = _.find(categories, (c) => c.cat1_id === cat1_id);
            const cat2 = cat1 ? _.find(cat1.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id) : null;
            const cat3 = cat2 ? _.find(cat2.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id && c.cat3_id === cat3_id) : null;
            // const catToShow = cat3 || cat2 || cat1
            if (!cat1) {
                return null
            }
            return <span key={"category_" + cat1_id} className="filter-label"><span>{currentLanguage === 'th' ? cat1.category_th : cat1.category} {cat2 ? " > " + (currentLanguage === 'th' ? cat2.category_th : cat2.category) : null} {cat3 ? " > " + (currentLanguage === 'th' ? cat3.category_th : cat3.category) : null}</span><span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.removeApplyingFilter("category", null, responsive) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
        } else if (type === "brand") {
            return <span key={"brand_" + value} className="filter-label"><span>{value}</span><span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.removeApplyingFilter("brand", null, responsive) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
        } else if (type === "promotion") {
            return _.map(value, (v, i) => {
                if (v) {
                    return <span key={"pro_label_" + i} className="filter-label"><span>{PROMOTIONS[i].name}</span><span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.removeApplyingFilter("promotion", i, responsive) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
                }
            })
        } else if (type === "product") {
            if (!Array.isArray(value)) return null;
            return <span key={"product_filter_1"} className="filter-label"><span>{value.join(", ")}</span><span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.removeApplyingFilter("product", null, responsive) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
        } else if (type === "origin") {
            return <span key={"origin_filter_1"} className="filter-label">Origin: {value}<span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.removeApplyingFilter("origin", null, responsive) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
        }
    }

    renderAllCurrentFilter(filter) {
        return [
            this.renderCurrentApplyingFilter("keyword", filter.keyword, false),
            this.renderCurrentApplyingFilter("product", filter.mat_var_id, false),
            this.renderCurrentApplyingFilter("category", _.pick(filter, ["cat1_id", "cat2_id", "cat3_id"]), false),
            this.renderCurrentApplyingFilter("promotion", filter.promotion, false),
            this.renderCurrentApplyingFilter("brand", filter.brand_en, false),
            this.renderCurrentApplyingFilter("origin", filter.origin, false)
        ]
    }

    getSortCurrent(sort) {
        return _.find(sortOptions, (s) => s.value === sort.value).label;
    }

    getSubCats(currentCategory) {
        const { currentLanguage, countMatByCat, categories } = this.props;
        const { applyingFilter } = this.state;
        const userCategory = applyingFilter.category || currentCategory;
        const SUB_CAT = userCategory.cat3_id ? [] : userCategory.cat2_id ? _.find(_.find(categories, (c1) => c1.cat1_id === userCategory.cat1_id).subCategories, (c) => c.cat1_id === userCategory.cat1_id && c.cat2_id === userCategory.cat2_id).subCategories : (userCategory.cat1_id ? _.find(categories, (c) => c.cat1_id === userCategory.cat1_id).subCategories : categories);
        let result = _.filter(SUB_CAT, _.matches(userCategory));
        result = _.filter(result, (r) => {
            const tmp = _.find(countMatByCat, (c) => {
                return (c.cat1_id === r.cat1_id) &&
                    ((typeof r.cat2_id === "undefined" && c.cat2_id === null) || (typeof r.cat2_id !== "undefined" && c.cat2_id === r.cat2_id)) &&
                    ((typeof r.cat3_id === "undefined" && c.cat3_id === null) || (typeof r.cat3_id !== "undefined" && c.cat3_id === r.cat3_id));
            });
            return tmp ? tmp.count : false;
        })
        return _.map(result, (r, i) => {
            return <li key={"category_" + i} onClick={() => { this.setCategoryFilter(_.pick(r, ['cat1_id', 'cat2_id', 'cat3_id'])) }}>{currentLanguage === 'th' ? r.category_th : r.category}</li>
        })
    }

    getPromotionList() {
        const { applyingFilter } = this.state;
        const currentPromotion = applyingFilter.promotion
        return _.map(PROMOTIONS, (promo, i) => {
            return (
                <li key={"promo_" + i} >
                    <label className="checkbox-container mb-0">{promo.name}
                        <input type="checkbox" checked={_.get(currentPromotion, `[${i}]`, 0) !== 0 || false} onChange={() => { this.setPromotionFilter(promo.value, i, false) }} />
                        <span className="checkmark"><div className="checkmark-icon" /></span>
                    </label>
                </li>
            )
        });
    }

    renderApplyingCategory() {
        const { currentLanguage, categories } = this.props;
        const { applyingFilter } = this.state;
        const category = applyingFilter.category
        if (!category) return null;
        const components = [];
        let removeable = true;
        const { cat1_id, cat2_id, cat3_id } = category
        const cat1 = _.find(categories, (c) => c.cat1_id === cat1_id);
        const cat2 = cat1 ? _.find(cat1.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id) : null;
        const cat3 = cat2 ? _.find(cat2.subCategories, (c) => c.cat1_id === cat1_id && c.cat2_id === cat2_id && c.cat3_id === cat3_id) : null;
        if (cat3) {
            removeable = false;
            components.unshift(
                <span key={`category_${cat1_id}_${cat2_id}_${cat3_id}`} className="filter-label"><span>{currentLanguage === 'th' ? cat3.category_th : cat3.category}</span><span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.setCategoryFilter({ cat1_id, cat2_id }) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
            )
            components.unshift(<FontAwesomeIcon key={`chevron_${cat1_id}_${cat2_id}_${cat3_id}`} icon={faChevronRight} />)
        }
        if (cat2) {
            if (removeable) {
                removeable = false;
                components.unshift(
                    <span key={`category_${cat1_id}_${cat2_id}`} className="filter-label"><span>{currentLanguage === 'th' ? cat2.category_th : cat2.category}</span><span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.setCategoryFilter({ cat1_id }) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
                )
                components.unshift(<FontAwesomeIcon key={`chevron_${cat1_id}_${cat2_id}`} icon={faChevronRight} />)
            } else {
                components.unshift(
                    <span key={`category_${cat1_id}_${cat2_id}`} className="" onClick={(e) => { e.stopPropagation(); this.setCategoryFilter({ cat1_id: cat2.cat1_id, cat2_id: cat2.cat2_id }) }}><span>{currentLanguage === 'th' ? cat2.category_th : cat2.category}</span></span>
                )
                components.unshift(<FontAwesomeIcon key={`chevron_${cat1_id}_${cat2_id}`} icon={faChevronRight} />)
            }
        }
        if (cat1) {
            if (removeable) {
                components.unshift(
                    <span key={`category_${cat1_id}`} className="filter-label"><span>{currentLanguage === 'th' ? cat1.category_th : cat1.category}</span><span className="remove-filter-label" onClick={(e) => { e.stopPropagation(); this.setCategoryFilter({}) }}><FontAwesomeIcon icon={["fal", "times"]} /></span></span>
                )
            } else {
                components.unshift(
                    <span key={`category_${cat1_id}`} className="" onClick={(e) => { e.stopPropagation(); this.setCategoryFilter({ cat1_id: cat1.cat1_id }) }}><span>{currentLanguage === 'th' ? cat1.category_th : cat1.category}</span></span>
                )
            }
        }
        return components;
    }

    render() {
        const { products, filter, brands, sort, seo, currentLanguage, categories, hasMore } = this.props;
        const { sortVisible, categoryFilterVisible, promotionFilterVisible, filterWindowVisible, brandBanner, catSEOText, vh } = this.state; //priceVisible, ratingVisible, applyingFilter, promotionVisible, categoryVisible, 

        let seoTitle, seoKewords, noTailTitle, seoDescription
        if (seo) {
            seoTitle = seo.title;
            seoKewords = seo.keywords;
            seoDescription = seo.description || '';
            noTailTitle = seo.noTailTitle;
        }

        let backdropHeight = 0;
        if (this.sortBox) {
            backdropHeight = (window.innerHeight - this.sortBox.getBoundingClientRect().top) + "px";
        }

        return (
            <Page title={(seoTitle && seoTitle !== "") ? seoTitle : `${brandTitle ? brandTitle + " " : ""}${brandTitle !== title ? title : ""}`} noTailTitle={noTailTitle} id="store" keyword={seoKewords ? seoKewords : `${title ? title + ", " : ""}${brandTitle !== title ? brandTitle : "store, ร้านค้า, ช้อปปิ้ง, โปรโมชั่น, ขายดี, ซื้อเยอะถูกกว่า, ชิ้นที่ 2 ราคาพิเศษ, ลดราคา, หั่นราคา, ซื้อครบได้แถม, แพคประหยัดสุดคุ้ม"}`} noDefaultKeywords={brandTitle ? true : false} description={seoDescription !== '' ? seoDescription : `หาสินค้า สั่งซื้อสินค้า${title !== 'ร้านค้าออนไลน์' ? `หมวดหมู่ ${title}` : ``}${brandTitle !== '' ? ` จากแบรนด์ ${brandTitle}` : ``} ของแท้ 100% ทุกชิ้น พร้อมโปรโมชั่นสุดพิเศษกว่าใครกับ BEAUTRIUM Online Store พร้อมกับโปรโมชั่นและคูปองสิทธิพิเศษอื่น ๆ อีกเพียบที่ บิวเทรี่ยม ออนไลน์`}>
                <div className={`filter-backdrop ${filterWindowVisible ? "visible" : "hidden"}`} style={{ top: 0 }}>
                    <div className={`filter-drawer ${filterWindowVisible ? "visible" : "hidden"}`} ref={e => this.filterDrawerBox = e} style={{ height: vh }}>
                        <div className={`close-btn`} onClick={this.filterDrawerHandleClick}><FontAwesomeIcon icon={faTimes} /></div>
                        <div className="header">ตัวกรอง</div>
                        <div className="fitler-groups">
                            <DrawerCategoryFilter getSubCats={() => this.getSubCats(_.pick(filter, ["cat1_id", "cat2_id", "cat3_id"]))} clearCategoryFilter={() => this.setCategoryFilter({})} renderApplyingCategory={this.renderApplyingCategory} />
                            <DrawerPromotionFilter getPromotionList={() => this.getPromotionList()} />
                            <DrawerBrandFilter brands={brands} params={this.props.match.params} applyingFilter={this.state.applyingFilter} setBrandFilter={(brand_en, isAdding, isApplying) => this.setBrandFilter(brand_en, isAdding, isApplying)} />
                        </div>

                        <div className="filter-commands">
                            <div className="reset" onClick={() => this.clearAllFilters(true)}>รีเซ็ต</div>
                            <button className="btn btn-black" type="button" onClick={() => { this.filterDrawerHandleClick(); this.applyFilter(); }}>ยืนยัน</button>
                        </div>
                    </div>
                </div>
                <div className="container store-content">

                    <div className="controls row d-flex d-lg-none">
                        <div>
                            <span onClick={this.sortHandleClick}>{this.getSortCurrent(sort)} <FontAwesomeIcon icon={faChevronDown} /></span>
                            <div className={`sort-list ${sortVisible ? "visible" : "hidden"}`} ref={(b) => { this.sortBox = b }} onClick={this.sortHandleClick} style={{ height: backdropHeight }}>
                                <div className={`sort-dropdown ${sortVisible ? "visible" : "hidden"}`}>
                                    <ul>
                                        <li><span onClick={() => this.setSortField({ value: 'new_arrivals' })}>สินค้าใหม่</span></li>
                                        <li><span onClick={() => this.setSortField({ value: 'best_sellers' })}>สินค้าขายดี</span></li>
                                        <li><span onClick={() => this.setSortField({ value: 'plth' })}>ราคาต่ำ - สูง</span></li>
                                        <li><span onClick={() => this.setSortField({ value: 'phtl' })}>ราคาสูง - ต่ำ</span></li>
                                        {/* <li><span onClick={() => this.setSortField({value: 'top_rate'})}>ความนิยม</span></li> */}
                                        {/* <li><span onClick={() => this.setSortField({value: 'batz'})}>แบรนด์จากน้อยไปมาก</span></li> */}
                                        {/* <li><span onClick={() => this.setSortField({value: 'bzta'})}>แบรนด์จากมากไปน้อย</span></li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div style={{ color: "#d0d2d3" }}>|</div>
                        <div>
                            <span onClick={this.categoryFilterHandleClick}>หมวดหมู่สินค้า <FontAwesomeIcon icon={faChevronDown} /></span>
                            <div className={`filter-backdrop ${categoryFilterVisible ? "visible" : "hidden"}`} style={{ height: backdropHeight }}>
                                <div className={`category-filter-dropdown ${categoryFilterVisible ? "visible" : "hidden"}`} ref={(b) => { this.categoryFilterBox = b }} >
                                    <div className="d-flex justify-content-between category-current-filter">
                                        <div className="applying-category"><span onClick={() => this.setCategoryFilter({})}>ทั้งหมด</span> <FontAwesomeIcon icon={faChevronRight} /> {this.renderApplyingCategory()}</div>
                                    </div>
                                    <ul>
                                        {this.getSubCats(_.pick(filter, ["cat1_id", "cat2_id", "cat3_id"]))}
                                    </ul>
                                    <div className="filter-commands">
                                        <div className="reset" onClick={() => this.setCategoryFilter({})}>รีเซ็ต</div>
                                        <button className="btn btn-black" type="button" onClick={() => { this.applyFilter(); this.categoryFilterHandleClick() }}>ยืนยัน</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ color: "#d0d2d3" }}>|</div>
                        <div>
                            <span onClick={this.promotionFilterHandleClick}>โปรโมชั่น <FontAwesomeIcon icon={faChevronDown} /></span>
                            <div className={`filter-backdrop ${promotionFilterVisible ? "visible" : "hidden"}`} style={{ height: backdropHeight }}>
                                <div className={`promotion-filter-dropdown ${promotionFilterVisible ? "visible" : "hidden"}`} ref={(b) => { this.promotionFilterBox = b }} >
                                    {/* <div className="d-flex justify-content-between promotion-current-filter">
                                        <div className="applying-promotion"><span onClick={() => this.setPromotionFilter({})}>ทั้งหมด</span> <FontAwesomeIcon icon={faChevronRight} /> {this.renderApplyingPromotion()}</div>
                                    </div> */}
                                    <div className="header">โปรโมชั่น</div>
                                    <ul>
                                        {this.getPromotionList()}
                                    </ul>
                                    <div className="filter-commands">
                                        <div className="reset" onClick={() => this.setPromotionFilter(null, null, false)}>รีเซ็ต</div>
                                        <button className="btn btn-black" type="button" onClick={() => { this.applyFilter(); this.promotionFilterHandleClick() }}>ยืนยัน</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ color: "#d0d2d3" }}>|</div>
                        <div><span onClick={this.filterDrawerHandleClick}><FontAwesomeIcon icon={faFilter} /> ตัวกรอง</span></div>
                    </div>
                    {this.renderHeaderBanner(brandBanner)}
                    <div className="row content">
                        {this.renderAllCurrentFilter(this.props.filter).length !== 0 && <div className="filter-values nowrap-scroll d-md-none">
                            {this.renderAllCurrentFilter(this.props.filter)}
                        </div>}
                        <div className="d-none d-xl-inline-block col-xl-3 filter-container">
                            <ul className="bt-breadcrumb">
                                <li><Link to="/">Home</Link><FontAwesomeIcon icon={["fal", "chevron-right"]} className="ml-2" /></li>
                                <li><span style={{ cursor: 'pointer', color: '#A7A7A7' }} onClick={() => {
                                    this.props.setFilter({});
                                    this.props.setSort({ value: "new_arrivals" });
                                    this.props.history.push('/shop');
                                    this.refresh();
                                }}>BEAUTRIUM Store</span><FontAwesomeIcon icon={["fal", "chevron-right"]} className="ml-2" /></li>
                                {this.renderBreadCrumb()}
                            </ul>
                            {this.renderAllCurrentFilter(this.props.filter).length !== 0 && <div className="filter-values">
                                {this.renderAllCurrentFilter(this.props.filter)}
                            </div>}
                            <div className="filter-category">
                                <h6 className="header">หมวดหมู่สินค้า</h6>
                                <ul>
                                    <FilterMenuComponent menu={categories} queryString={this.props.location.search} setFilter={this.setCategoryFilter} />
                                </ul>
                            </div>
                            <div className="filter-promotion">
                                <h6 className="header">โปรโมชั่น</h6>
                                <ul className="brands">
                                    {_.map(PROMOTIONS, (promotion, index) => {
                                        return (
                                            <li key={`promotion_checkbox_${index}`}>
                                                <label className="checkbox-container" style={{ cursor: "pointer" }}>{promotion.name}
                                                    <input type="checkbox" checked={_.get(this.props.filter, `promotion[${index}]`, false)} onChange={() => { this.setPromotionFilter(promotion.value, index) }} />
                                                    <span className="checkmark"><div className="checkmark-icon" /></span>
                                                </label>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            {/* <div className="filter-price">
                                <h6 className="header">Price</h6>
                                <div className="text-center">
                                    <InputRangeWrapper isApplying={true} setPriceFilter={this.setPriceFilter} />
                                </div>
                            </div> */}
                            {(typeof filter.brand_en === "undefined" || !filter.brand_en || filter.brand_en === "") &&
                                <div className="filter-brand form-group">
                                    <h6 className="header form-control-label">แบรนด์</h6>
                                    <input type="text" className="form-control" placeholder="ค้นหาแบรนด์" onChange={(e) => { this.setState({ brandsChoiceFilter: e.target.value }) }} value={this.state.brandsChoiceFilter} />
                                    <div className="overflow-scroll-gradient">
                                        <ul className="brands">
                                            {this.renderBrandsCheckbox(brands)}
                                        </ul>
                                    </div>
                                </div>}
                            {/* <div className="filter-rating">
                                <h6 className="header">Rating</h6>
                                <Rating 
                                    emptySymbol={<FontAwesomeIcon icon={["fal", "heart"]} style={{color: "#ccc"}} />}
                                    fullSymbol={<FontAwesomeIcon icon={["fas", "heart"]} style={{color: "#d50032"}} />}
                                    // emptySymbol={<img src={emptyIcon} className="rating-icon" />}
                                    // fullSymbol={<img src={fullIcon} className="rating-icon" />}
                                    initialRating={this.state.rateFilter}
                                    onChange={(v) => {this.setRateFilter(v)}}
                                />
                            </div> */}
                            <div className="filter-cmd">
                                <button className="btn btn-white" onClick={() => this.clearAllFilters(false)}>รีเซ็ตการตั้งค่า</button>
                            </div>
                        </div>
                        <div className="col-12 col-xl-9 grid-container">
                            <div className="sort-pagination-row d-none d-xl-flex align-items-center">
                                <div className="sort-container">
                                    <label className="mr-2">Sort:</label>
                                    <SelectBox
                                        options={sortOptions}
                                        selected={_.filter(sortOptions, (s) => s.value === sort.value)}
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                border: 'none',
                                                borderRadius: 0,
                                                borderBottom: "1px solid #979797",
                                                borderColor: "#979797",
                                                boxShadow: 'none',
                                                width: 200,
                                            }),
                                            indicatorSeparator: () => ({
                                                display: 'none'
                                            })
                                        }}
                                        input={
                                            { onChange: (value) => this.setSortField(value, false) }
                                        }
                                    />
                                </div>
                                <div className="pagination-container">
                                    <Pagination currentPage={this.props.page} hasMore={hasMore} setPage={(newPage) => this.props.setPage(newPage, this.props.filter.brand_en)} />
                                </div>
                            </div>
                            <div className="product-grid">
                                <ProductGrid products={products} refresh={this.refresh} />
                            </div>
                            <div className="pagination-row">
                                <div className="pagination-container">
                                    <Pagination currentPage={this.props.page} hasMore={hasMore} setPage={(newPage) => this.props.setPage(newPage, this.props.filter.brand_en)} />
                                </div>
                            </div>
                            <div className="seo-text d-none d-xl-block">
                                {catSEOText && <h1>{currentLanguage === 'th' ? _.find(categories, (c) => c.cat1_id === catSEOText).category_th : _.find(categories, (c) => c.cat1_id === catSEOText).category}</h1>}
                                {this.renderSEOText()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="" style={{ marginBottom: "30px" }}>
                    <CallToAction />
                </div>
            </Page>
        );
    }

}

class DrawerCategoryFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: true,
        }
    }

    render() {
        const { getSubCats, clearCategoryFilter, renderApplyingCategory } = this.props;
        const { visible } = this.state;
        let props = {};
        if (visible) {
            props = { rotation: 90 }
        }
        return (
            <div className="filter-group filter-category">
                <div className="filter-group-header" onClick={() => this.setState(prev => { return { visible: !prev.visible } })}>
                    <span className="title">หมวดหมู่</span>
                    <span className={`caret`}><FontAwesomeIcon icon={faChevronRight} {...props} /></span>
                </div>
                <div className={`filter-group-content ${visible ? "visible" : "hidden"}`}>
                    <div className="d-flex justify-content-between category-current-filter">
                        <div className="applying-category"><span onClick={clearCategoryFilter}>ทั้งหมด</span> <FontAwesomeIcon icon={faChevronRight} /> {renderApplyingCategory()}</div>
                    </div>
                    <div className="filter-values">
                        <ul>
                            {getSubCats()}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
class DrawerPromotionFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
        }
    }

    render() {
        const { getPromotionList } = this.props;
        const { visible } = this.state;
        let props = {};
        if (visible) {
            props = { rotation: 90 }
        }
        return (
            <div className="filter-group filter-promotion">
                <div className="filter-group-header" onClick={() => this.setState(prev => { return { visible: !prev.visible } })}>
                    <span className="title">โปรโมชั่น</span>
                    <span className={`caret`}><FontAwesomeIcon icon={faChevronRight} {...props} /></span>
                </div>
                <div className={`filter-group-content ${visible ? "visible" : "hidden"}`}>
                    <div className="filter-values">
                        <ul>
                            {getPromotionList()}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
class DrawerBrandFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            brandListFilter: null,
            brandListFilterInput: "",
        }

        this._renderBrandsCheckbox = this._renderBrandsCheckbox.bind(this);
    }

    _renderBrandsCheckbox(brands) {
        const { applyingFilter, setBrandFilter } = this.props;
        const { brandListFilter, brandListFilterInput } = this.state;
        const { params: { param1, param2, param3, param4 } } = this.props;
        const tailUrl = _.compact([param1, param2, param3, param4]).join("/")
        let pattern = '';
        if (brandListFilter === "num") {
            pattern = `^\\d`; //eslint-disable-line
        } else if (brandListFilter) {
            pattern = `^${brandListFilter}`;
        }
        if (brandListFilterInput) {
            let f = brandListFilterInput.toUpperCase();
            if ((brandListFilter === "num" && f.match(/^\d.*/)) || f.startsWith(brandListFilter)) {
                f = f.substr(1);
            }
            pattern += `${f.toUpperCase()}.*`;
        } else {
            pattern += `.*`;
        }
        const re = RegExp(pattern, 'i');
        const brandFiltered = _.filter(brands, (b) => {
            return re.test(b.brand_en)
        });

        return _.map(brandFiltered, (brand, index) => {
            return (
                <BrandCheckbox key={brand.brand_id + " " + index} brand={brand} responsive={true} tailUrl={tailUrl} setBrandFilter={(v) => { setBrandFilter(brand.brand_en, v, false) }} filterValue={brand.brand_en === applyingFilter.brand} />
            );
        });
    }

    render() {
        const { brands } = this.props;
        const { brandListFilter, visible, brandListFilterInput } = this.state;
        let props = {};
        if (visible) {
            props = { rotation: 90 }
        }
        return (
            <div className="filter-group filter-brand">
                <div className="filter-group-header" onClick={() => this.setState(prev => { return { visible: !prev.visible } })}>
                    <span className="title">แบรนด์</span>
                    <span className={`caret`}><FontAwesomeIcon icon={faChevronRight} {...props} /></span>
                </div>
                <div className={`filter-group-content ${visible ? "visible" : "hidden"}`}>
                    <div className="form-group">
                        <input className="form-control" type="text" placeholder="ค้นหาแบรนด์" onChange={(e) => this.setState({ brandListFilterInput: e.target.value })} value={brandListFilterInput} />
                    </div>
                    <div className="filter-search-alphabet">
                        <ul>
                            <li className={`all ${!brandListFilter ? "active" : ""}`} onClick={() => this.setState({ brandListFilter: null })}>ALL</li>
                            <li className={`all ${brandListFilter === "num" ? "active" : ""}`} onClick={() => this.setState({ brandListFilter: "num" })}>0 - 9</li>
                            {_.times(26, (n) => {
                                return <li key={"a_" + n} className={`${brandListFilter === String.fromCharCode(65 + n) ? "active" : ""}`} onClick={() => this.setState({ brandListFilter: String.fromCharCode(65 + n) })}>{String.fromCharCode(65 + n)}</li>
                            })}
                        </ul>
                    </div>
                    <div className="filter-values">
                        <ul>
                            {this._renderBrandsCheckbox(brands)}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        products: state.materials.materials,
        products_count: state.materials.materials_count,
        hasMore: state.materials.hasMore,
        filter: state.materials.filter,
        page: state.materials.page,
        pageBrand: state.materials.pageBrand,
        brands: state.materials.brands,
        sort: state.materials.sort,
        countMatByCat: state.materials.countMatByCat,
        addWishlistResult: state.prof.addWishlistResult,
        deleteWishlistResult: state.prof.deleteWishlistResult,
        translate: getTranslate(state.locale),
        seo: state.seo,
        categories: state.itemCategories.categories,
        currentLanguage: getActiveLanguage(state.locale).code,
    }
}
export default connect(mapStateToProps, { addToCart, toggleWishlistItem, lockScroll, getProducts, setFilter, getBrands, setSort, setPage, getCountByCategory, getTranslate, getSEO })(frontloadConnect(frontload, { onMount: true, onUpdate: false })(StoreGrid));